'use client'

import { ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import { useLayout } from '../providers/LayoutProvider'
import FullLayoutTemplate from './FullLayoutTemplate'
import ShortLayoutTemplate from './ShortLayoutTemplate'
import NoLayoutTemplate from './NoLayoutTemplate'

interface LayoutSelectorProps {
  children: ReactNode
  brand?: any
  globalData?: any
  loginEl?: any
  setLoginEl?: any
  headerMenuJson?: any
  footerJson?: any
  pageInserts?: any
  env?: string
}

/**
 * Layout Selector - Chooses the appropriate layout template based on the current route
 */
export default function LayoutSelector(props: LayoutSelectorProps) {
  const pathname = usePathname()
  const layoutContext = useLayout()
  
  // Merge props with context data (props take precedence if provided)
  const brand = props.brand || layoutContext.brand
  const globalData = props.globalData || layoutContext.globalData
  const loginEl = props.loginEl || layoutContext.loginEl
  const setLoginEl = props.setLoginEl || layoutContext.setLoginEl
  const headerMenuJson = props.headerMenuJson || layoutContext.headerMenuJson
  const footerJson = props.footerJson || layoutContext.footerJson
  const pageInserts = props.pageInserts || layoutContext.pageInserts
  const env = props.env || layoutContext.env
  
  // Define route patterns for different layout types
  const noLayoutRoutes = [
    '/login',
    '/successconfirmation',
    '/product3d'
  ]
  
  const shortLayoutRoutes = [
    '/stylequiz',
    '/roomquiz', 
    '/recommendations',
    '/builder',
    '/cart',
    '/uploadInstructions'
  ]
  
  // Check if current path matches any pattern
  const currentPath = pathname || ''
  
  const isNoLayout = noLayoutRoutes.some(route => currentPath.startsWith(route)) ||
                     currentPath.includes('threed')
  
  const isShortLayout = shortLayoutRoutes.some(route => currentPath.startsWith(route))
  
  // Prepare merged layout data to pass to templates
  const layoutData = {
    brand,
    globalData,
    loginEl,
    setLoginEl,
    headerMenuJson,
    footerJson,
    pageInserts,
    env
  }
  
  // Select appropriate template
  if (isNoLayout) {
    return <NoLayoutTemplate>{props.children}</NoLayoutTemplate>
  }
  
  if (isShortLayout) {
    return <ShortLayoutTemplate {...layoutData}>{props.children}</ShortLayoutTemplate>
  }
  
  // Default to full layout
  return <FullLayoutTemplate {...layoutData}>{props.children}</FullLayoutTemplate>
}